import { LocaleStrings } from '../keys';

const zh: LocaleStrings = {
  nav_home: 'Home',
  nav_search_label: 'Search',
  nav_profile: 'Profile',
  header_btn_create: 'Create Story',
  header_user_default: 'User',
  header_sign_out: 'Sign Out',
  search_placeholder: 'Searchâ€¦',
  theme_toggle_light: 'Switch to Light Mode',
  theme_toggle_dark: 'Switch to Dark Mode',

  nav_stories: 'æ•…äº‹',
  nav_create: 'åˆ›ä½œ',
  nav_login: 'ç™»å½•',

  page_title_main: 'Story Craft - ä¸»é¡µ',
  section_browse_by_category: 'æŒ‰ç±»åˆ«æµè§ˆ',
  section_explore_new_games: 'æŽ¢ç´¢æ–°æ¸¸æˆ',
  section_popular: 'çƒ­é—¨',
  section_trending: 'è¶‹åŠ¿',
  section_trending_now: '实时热搜',
  section_popular_picks: '热门精选',
  section_recent_stories: 'æœ€è¿‘æµè§ˆ',
  section_new_stories: 'æ–°æ•…äº‹',
  btn_load_more_games: 'åŠ è½½æ›´å¤šæ¸¸æˆï¼ˆè¿˜æœ‰ {count} ä¸ªï¼‰',
  text_showing_games: 'æ˜¾ç¤º {visible} / {total} ä¸ªæ¸¸æˆ',
  text_no_category_games: 'æ²¡æœ‰æ‰¾åˆ° {category} ç±»æ¸¸æˆã€‚',
  text_category_games: '{category} æ¸¸æˆ',
  text_error_loading_games: 'åŠ è½½æ¸¸æˆå¤±è´¥ï¼š{error}',

  tell_us_tagline: 'Story Craftï¼šè®©åŒäººå°è¯´æˆä¸ºå¯çŽ©çš„æ•…äº‹ã€‚',
  tell_us_subtitle: 'ä»Šå¤©å°±å¼€å§‹åˆ›ä½œä½ çš„æ¸¸æˆï¼',
  btn_create_now: 'ç«‹å³åˆ›ä½œ',

  section_comments: 'è¯„è®º ({count})',
  text_no_comments: 'è¿˜æ²¡æœ‰è¯„è®ºã€‚æˆä¸ºç¬¬ä¸€ä¸ªåˆ†äº«æƒ³æ³•çš„äººï¼',
  btn_load_more_comments: 'åŠ è½½æ›´å¤šè¯„è®º',
  text_posting_comment: 'æ­£åœ¨å‘è¡¨è¯„è®º...',
  text_failed_load_comments: 'åŠ è½½è¯„è®ºå¤±è´¥',
  text_login_to_view_comments: 'Login to view comments',

  page_title_game_not_found: 'æ¸¸æˆæœªæ‰¾åˆ° - Story Craft',
  page_title_game_info: 'æ¸¸æˆä¿¡æ¯ - Story Craft',
  btn_play_now: 'å¼€å§‹æ¸¸æˆ',
  btn_rate: 'è¯„åˆ†',
  section_about: 'å…³äºŽ',
  section_tags: 'æ ‡ç­¾',
  text_views: '{count} æ¬¡æµè§ˆ',
  text_your_rating: 'ä½ çš„è¯„åˆ†ï¼š{rating} - {title}',
  text_game_id: 'æ¸¸æˆ IDï¼š{id}',
  text_no_description: 'è¿™ä¸ªæ¸¸æˆæ²¡æœ‰æè¿°ã€‚',
  text_game_not_found: 'æ¸¸æˆæœªæ‰¾åˆ°',
  text_failed_load_game: 'åŠ è½½æ¸¸æˆä¿¡æ¯å¤±è´¥',

  section_similar_games: 'ç±»ä¼¼æ¸¸æˆ',
  text_failed_load_similar: 'åŠ è½½ç±»ä¼¼æ¸¸æˆå¤±è´¥',

  prefooter_btn_start: 'ðŸš€ Start for free',
  prefooter_btn_learn: 'Learn more â†’',

  hero_eyebrow: 'âœ¨ The #1 Interactive Story Creation Platform',
  hero_title: 'Zingplay Story Craft - Tell Your Story',
  hero_subtitle: 'Explore thousands of exciting stories from the creative community. Write, read, and share stories that touch hearts.',
  hero_btn_create: 'ðŸš€ Start Creating',
  hero_btn_explore: 'ðŸ“– Explore Stories',
  hero_stat_stories: '12,000+ Stories',
  hero_stat_authors: '5,000+ Authors',
  hero_stat_rating: '4.9 Rating',

  prefooter_title: 'Ready to tell your story?',
  prefooter_subtitle: 'Join 5,000+ authors creating every day on StoryCraft',
  footer_tagline: 'The #1 Interactive Story Creation Platform',

  footer_terms: 'Terms',
  footer_report: 'Report',
  footer_contact: 'Contact',

  section_story_craft_comments: 'Story Craft è¯„è®º - åœ¨æ­¤æé—®å’Œå›žç­”',

  section_featured: 'Story Craft ç²¾é€‰',
  section_top_genre: 'Top {genre} æ•…äº‹',

  translate_popup_eyebrow: 'AI TRANSLATION',
  translate_popup_title: 'Translate story to {targetLang}?',
  translate_popup_message: 'This story is in {originLang}. Do you want to open it with the {targetLang} translation?',
  translate_popup_note: 'Translations are AI-generated and may not be perfect.',
  translate_popup_btn_translate: 'Translate now',
  translate_popup_btn_keep: 'Keep original',
  translate_progress_title: 'Translating storyâ€¦',
  translate_progress_subtitle: 'AI is translating to {targetLang}',
  translate_progress_step_analyze: 'Analyzing contentâ€¦',
  translate_progress_step_generate: 'Generating translationsâ€¦',
  translate_progress_step_pack: 'Updating language packâ€¦',
  translate_progress_step_done: 'All done!',
  translate_progress_flavor_1: 'Reading dialogueâ€¦',
  translate_progress_flavor_2: 'Translating character linesâ€¦',
  translate_progress_flavor_3: 'Converting choicesâ€¦',
  translate_progress_flavor_4: 'Syncing tone of voiceâ€¦',
  translate_progress_flavor_5: 'Proofreadingâ€¦',
  translate_error_title: 'Translation failed',
  translate_error_message: 'Could not translate story: {error}. The story will open in its original language.',
  translate_error_btn_ok: 'Got it',
  event_vote_section_title: 'Participating in Events',
  event_vote_btn: 'Vote',
  event_voted_btn: 'Voted',
  event_vote_count: '{count} votes',

  section_events: 'Events',
  btn_event_detail: 'Details',
  event_ranking_title: 'Story Rankings',
  event_winners_title: 'Winners',
  event_winners_subtitle: 'Top stories that won badges from this event.',
  event_time_label: 'Event Period',
  event_status_not_started: 'Starts in {days} days',
  event_status_starting_soon: 'Starts in {time}',
  event_status_ended: 'Ended',
  event_status_ongoing: '{days} days left',
  event_status_ending_soon: '{time} left',
  event_today_label: 'Today',
  event_day_elapsed: 'Day {day}',
  event_total_days: '{days} days',
  event_votes_label: 'votes',
  event_not_found: 'Event not found or has ended',
  event_not_found_sub: 'Go back to the home page to see ongoing events.',
  event_empty_stories: 'No stories have joined this event yet',
  event_empty_stories_sub: 'Be the first to publish a story and join!',
  event_modal_title: 'Join Event',
  event_modal_no_events: 'No events currently open.',
  event_modal_joined_badge: 'Joined',
  event_modal_go_to_event: 'View event',
  event_modal_join_btn: 'Join',
  event_modal_confirm_title: 'Confirm join',
  event_modal_confirm_body: 'Are you sure you want to join "{name}"? This cannot be undone.',
  event_modal_confirm_btn: 'Confirm join',
  profile_my_profile: 'My Profile',
  profile_tab_badges: 'Badges',
  profile_tab_stories: 'Stories',
  profile_tab_discussion: 'Discussion',
  profile_tab_notifications: 'Notifications',
  profile_notif_empty: 'No notifications yet.',
  profile_notif_game_approved: 'Your story has been approved.',
  profile_notif_game_rejected: 'Your story update was rejected.',
  profile_notif_new_badge: 'You earned a new badge!',
  profile_coming_soon_title: 'Coming Soon',
  profile_coming_soon_sub: 'The Badge system is being developed. Your achievements and titles will appear here.',
  profile_my_stories: 'My Stories',
  profile_stories_guest: 'Stories',
  profile_btn_new_story: 'New Story',
  profile_btn_manage: 'Manage',
  profile_btn_event: 'Event',
  profile_stat_stories: 'Stories',
  profile_stat_views: 'Total Views',
  profile_stat_star: 'Top Star',
  profile_btn_follow: 'Follow',
  profile_btn_message: 'Message',
  profile_discussion_placeholder: 'Leave a message for the author...',
  profile_discussion_login: 'Log in to comment',
  profile_btn_send: 'Send',
  profile_btn_reply: 'Reply',
  profile_btn_hide_comment: 'Hide',
  profile_btn_show_comment: 'Show',
  profile_no_comments: 'No comments yet. Be the first!',
  profile_load_more: 'Load more',
  profile_edit_title: 'Edit Profile',
  profile_edit_change_avatar: 'Change Avatar',
  profile_upload_avatar_error: 'Failed to upload avatar. Please try again.',
  profile_edit_fullname: 'Full Name',
  profile_edit_bio: 'Bio',
  profile_edit_save: 'Save',
  profile_shelf_empty: 'Your story shelf is empty',
  profile_shelf_empty_sub: 'Spin up your first interactive story in StoryCraft Studio. It only takes a few minutes to publish a draft.',
  profile_btn_create_first: 'Create your first story',
  profile_btn_load_more_stories: 'Load more stories',
  profile_save_error: 'Failed to save profile. Please try again.',
  profile_hide_error: 'Failed to hide comment.',
  profile_comment_error: 'Failed to post comment. Please try again.',
  profile_reply_error: 'Failed to post reply. Please try again.',
  profile_btn_cancel: 'Cancel',
  profile_btn_logout: 'Sign out',
  profile_logout_confirm_title: 'Sign out?',
  profile_logout_confirm_body: 'Are you sure you want to sign out of this account? You will be returned to the home page.',
  profile_login_required_title: 'Sign in required',
  profile_login_required_body: 'Sign in to view your profile, your stories and earned badges.',

  rating_warn_title: '分级 {rating}',
  rating_warn_teen_body: '此故事评级为 T（青少年 13+），可能包含轻度暴力、暗示性内容或不适合年幼读者的内容。',
  rating_warn_mature_body: '此故事评级为 M（成人 18+），可能包含强烈暴力、成人主题或仅适合成年读者的内容。',
  rating_warn_continue: '继续',
  rating_warn_go_back: '返回',
  rating_warn_confirm_teen: '我确认我已年满13岁。',
  rating_warn_confirm_mature: '我确认我已年满18岁。',

  rating_section_title: '内容分级',
  rating_label_e: '所有人',
  rating_label_t: '青少年 13+',
  rating_label_m: '成人 18+',
  rating_desc_e: '适合所有年龄段的读者，内容适合所有人。',

  hero_dialog_1: '哈利·波特又不小心对你的故事施错咒语了。',
  hero_dialog_2: '谢赫拉查德还在日出前给Mina讲最后一个故事…',
  hero_dialog_3: '夏洛克·福尔摩斯发现了一个情节漏洞，并拒绝继续加载。',
  hero_dialog_4: '德古拉正在等待进入第2章的许可。',
  hero_dialog_5: '弗罗多不知怎的把你的存档文件掉进了末日火山。',
  hero_dialog_6: '哈利·波特和Mina正在争论是谁造成了时间线崩塌。',
  hero_dialog_7: '灰姑娘又错过了午夜，所以加载画面被延长了。',
  hero_dialog_8: '罗密欧与朱丽叶提前到达了你的坏结局。',
  hero_dialog_9: '爱丽丝打开了错误的兔子洞，进入了你的草稿文件夹。',
  hero_dialog_10: 'Mina承诺不再阅读禁书了。Mina说谎了。',
  hero_dialog_11: '梅林正在修补故事引擎中的一个魔法bug。',
  hero_dialog_12: '奥德修斯已经尝试到达下一章整整10年了。',
  hero_dialog_13: '弗兰肯斯坦博士碰了代码库。没有人再感到安全了。',
  hero_dialog_14: '彼得·潘拒绝让这个故事长大。',
  hero_dialog_15: '小王子问Mina为什么大人要写那么多悲剧结局。',
};
export default zh;
